import React from 'react';
import { motion } from 'framer-motion';
import { reveal } from '../utils/motion';
import { CaseStudyCard } from '../components/CaseStudyCard';
import { SiteHeader } from '../components/SiteHeader';
import { DrawnUnderline } from '../components/DrawnUnderline';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { caseStudies, heroMetrics } from '../data/caseStudies';
import { clientLogos } from '../data/clientLogos';
import { linkClass } from '../utils/linkClass';
export function Home() {
  return <div className="min-h-screen w-full bg-white font-sans text-ink" data-id="element-140" data-mp="24hk7bdldhjku">
      <div className="mx-auto flex max-w-[1347px] flex-col gap-[30px] px-5 py-10 md:px-10" data-id="element-141" data-mp="29fvgdm3ufq20">
        <SiteHeader data-id="element-142" data-mp="2dhywwp5ddku5" />

        <main className="flex flex-col gap-5 min-[700px]:gap-[30px]" data-id="element-143" data-mp="2dii1z59x8eqr">
          <section className="flex flex-col items-start gap-6 py-4 min-[700px]:flex-row min-[700px]:py-10 min-[700px]:items-center min-[700px]:justify-center min-[700px]:gap-10 md:py-20" data-id="element-144" data-mp="3kvtmpi7mzxzj">
            <motion.img src="https://cdn.magicpatterns.com/uploads/oThdsUnkXC7FRqpUL19do3/Meikson-Square.jpg" alt="Portrait of Michael Meikson" className="aspect-square w-[160px] shrink-0 rounded-full object-cover min-[700px]:w-[200px]" initial={{
            opacity: 0,
            x: -40
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={reveal} data-id="element-145" data-mp="30wjbung70q3t" />
            <div className="flex max-w-[880px] flex-1 flex-col gap-5 min-[700px]:flex-initial" data-id="element-146" data-mp="2hy6zytxwd24j">
              <motion.div className="flex flex-col gap-3" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              ...reveal,
              delay: 0.05
            }} data-id="element-147" data-mp="2d6xc9yvws8va">
                <h1 className="bg-[linear-gradient(to_bottom,#4a4a4a,#000000)] bg-clip-text text-headline font-semibold text-transparent" data-id="element-148" data-mp="23am1xefvpt3h">
                  18 years of experience across B2B SaaS, fintech, and healthcare.
                </h1>
                <p className="text-subhead text-muted" data-id="element-149" data-mp="1kkqqbobu2uip">
                  Specialize in driving business results through{' '}
                  <DrawnUnderline delay={2} data-id="element-150" data-mp="1omkj7afseu8b">improved usability</DrawnUnderline>.
                </p>
              </motion.div>
            </div>
          </section>

          <motion.section aria-label="Clients" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          ...reveal,
          delay: 0.15
        }} data-id="element-151" data-mp="1flmesr1fskp7">
            <ul className="grid grid-cols-3 items-center gap-x-4 gap-y-0 min-[700px]:gap-y-2 md:grid-cols-6" data-id="element-152" data-mp="23dkurobtz48o">
              {clientLogos.map(logo => <li key={logo.name} className="flex items-center justify-center" data-id="element-153" data-mp="1tkm480wrx3mf">
                  <img src={logo.src} alt={logo.name} className="block aspect-[2/1] w-full max-w-[200px] object-contain" data-id="element-154" data-mp="1yjgjwtzg2c2b" />
                </li>)}
            </ul>
          </motion.section>

          <ul aria-label="Results" className="grid w-full grid-cols-1 gap-3 sm:grid-cols-3 sm:gap-[30px]" data-id="element-155" data-mp="2r1uk30896a4k">
            {heroMetrics.map((m, i) => <motion.li key={m.label} className="flex flex-col rounded-[30px] bg-positive-bg p-5 [container-type:inline-size]" initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            ...reveal,
            delay: 0.3 + i * 0.06
          }} data-id="element-156" data-mp="fjhcw60kytv9" data-mpi={i}>
                <span className="whitespace-nowrap text-[clamp(22px,21cqw,40px)] font-normal leading-[1.35] tracking-[-0.02em] text-positive max-[699px]:text-[28px]" data-id="element-157" data-mp="3srkf1oozuj8s">
                  {m.value}
                </span>
                <span className="text-xl leading-[27px] tracking-[-0.02em] max-[699px]:text-base max-[699px]:leading-6" data-id="element-158" data-mp="5ofnd92e7ps5">
                  {m.label}
                </span>
              </motion.li>)}
          </ul>

          <section aria-label="Case studies" className="flex flex-col gap-[30px]" data-id="element-159" data-mp="1h4w6bcd5oojr">
            {caseStudies.map(study => <CaseStudyCard key={study.id} study={study} animate data-id="element-160" data-mp="27dwnwxez3t23" />)}
          </section>

          <section className="flex flex-col gap-[30px] pt-2" data-id="element-161" data-mp="2ccpyoi2vl5yk">
            <div className="flex flex-col gap-3" data-id="element-162" data-mp="2cd83w47imuim">
              <h2 className="text-headline font-semibold" data-id="element-163" data-mp="2hbjbe8ac8sxo">
                AI has become the core of my design practice.
              </h2>
              <p className="text-subhead text-muted" data-id="element-164" data-mp="2mcqj67chds4c">
                I prototype in code and can ship working software.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-[30px] md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-id="element-165" data-mp="2vbbyzuqkit1f">
              <div className="flex flex-col gap-10" data-id="element-166" data-mp="3020vjoh3ug7f">
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-167" data-mp="304nai96brxzo">
                <p data-id="element-168" data-mp="3513yn3diyccr">
                  My primary design tool is Magic Patterns, where I maintain working prototypes of client projects. 
                </p>
                <a href="https://project-unified-inbox-with-filtering-117.magicpatterns.app/" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-169" data-mp="3e221vjg52fua">
                  View RSI Prototype →
                </a>
              </div>
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-170" data-mp="tetoawzo6f57">
                <p data-id="element-171" data-mp="og8nowgi9tg8">
                  I built Percelo, an AEO (Answer Engine Optimization), tool solo in about two weeks with Claude Code. 
                </p>
                <a href="https://www.percelo.com" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-172" data-mp="1h3w4e0ennzxl">
                  Try Percelo →
                </a>
              </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/8x9mJt8jkvyUyDgp9GG3CK/Percelo-hero2.png" alt="Percelo AI visibility report open on a laptop" className="h-[325px] w-full self-start rounded-[30px] object-cover object-[50%_45%]" data-id="element-173" data-mp="24tyvad6u2zum" />
            </div>
          </section>

          <TestimonialsSection data-id="element-174" data-mp="26a3w32d4jod" />
        </main>

        <div className="pt-10" data-id="element-175" data-mp="3kl11izrsimee">
          <SiteHeader as="footer" data-id="element-176" data-mp="3kjpxcyufncmr" />
        </div>
      </div>
    </div>;
}